import { type FC } from 'react';
import { useHomePageContext } from '../HomePageContext';
import { getBillboardAdData } from 'dibs-google-ad-manager/exports/adHelpers';
import { BillboardBannerAd } from 'dibs-google-ad-manager/exports/BillboardBannerAd';
import { useAbsentAdHandler } from 'dibs-google-ad-manager/exports/hooks';
import {
    type AdBillboardPlacement,
    type AdBillboardBanner,
} from 'dibs-google-ad-manager/exports/types';

import classNames from 'classnames';
import dibsCss from 'dibs-css';

type Props = {
    billboardAdData: AdBillboardBanner;
    placement: AdBillboardPlacement;
    isDesktop: boolean;
};

const HpSharedBillboardAd: FC<Props> = ({ billboardAdData, placement, isDesktop }) => {
    const { isAbsentAd, onAbsentAd } = useAbsentAdHandler(billboardAdData.elementId);
    const isHomeBottomPlacement = placement === 'home-bottom';

    return (
        <div
            className={classNames({
                [dibsCss.mtSmaller]: !isAbsentAd,
                [dibsCss.mbMedium]: !isAbsentAd && !isDesktop && isHomeBottomPlacement,
            })}
        >
            <BillboardBannerAd
                {...billboardAdData}
                lazyLoad={isHomeBottomPlacement}
                onAbsentAd={onAbsentAd}
                isAbsentAd={isAbsentAd}
            />
        </div>
    );
};

type WrapperProps = {
    placement: AdBillboardPlacement;
};

export const HpSharedBillboardAdWrapper: FC<WrapperProps> = ({ placement }) => {
    const { isDesktop } = useHomePageContext();
    // Tablet should get mobile ad
    const adWidth = isDesktop ? 'desktop' : 'mobile';
    const billboardAdData = getBillboardAdData(placement)?.[adWidth];

    if (!billboardAdData) {
        return null;
    }

    return (
        <HpSharedBillboardAd
            billboardAdData={billboardAdData}
            placement={placement}
            isDesktop={isDesktop}
        />
    );
};
